exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* TEXTFIELD */\n\n/* LIST */\n\n/* ==========  Layout  ========== */\n\n/* BUTTON */\n\n/* ANIMATION */\n\n/* Small control size */\n\n.group-title {\n  padding-top: 5px;\n  width: 500px;\n  height: 20px;\n  font-weight: bold;\n  font-size: 20px;\n}\n\n.inline {\n  display: inline-block;\n}\n\n.sample-tracking-container {\n  box-shadow: 0px 0px 15px 3px #bebcbc;\n  border-radius: 4px;\n  opacity: 1;\n  background-color: white;\n  height: 100%;\n  margin: 20px;\n  margin-top: unset;\n  padding-left: 20px;\n  padding-top: 5px;\n  font-family: \"Source Sans Pro\";\n  width: 1165px;\n}\n\n", ""]);

// exports
